<template>
  <div class="drawer-container">
    <div>
      <div class="flex_between_center">
        <h3 class="drawer-title">通知</h3>
        <el-button size="mini" type="text" @click="handleReadAll()">全部已读</el-button>
      </div>
      <div :style="{height:height}" class="message_box">
        <el-row>
          <el-col :span="24">
            <el-badge v-for="(item,index) in list" :key="index" :is-dot="item.is_read?false:true" style="width:100%;margin:10px 0 0 0" class="item">
              <el-card shadow="hover" @click.native="!item.is_read?handleToRead(item):''">
                <div :style="{color:item.is_read?'#bbb':'#333'}">
                  <p class="fz-m">{{ item.message_text }}</p>
                  <p class="fz-s">{{ parseTime(item.create_time) }}</p>
                </div>
              </el-card>
            </el-badge>
          </el-col>
        </el-row>
      </div>
      <pagination v-if="total>0" :total="total" :page.sync="listQuery.page_no" :limit.sync="listQuery.page_size" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import {
  GetUserSystemMessages,
  SetMessageToRead,
  SetAllMessagesToRead,
  GetNewUserSystemMessages
} from '@/api/message'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { parseTime } from '@/utils/index'
export default {
  name: 'Settings',
  components: { Pagination },
  data() {
    return {
      BASE_CDN_API: process.env.BASE_CDN_API,
      listQuery: {
        page_size: 50,
        page_no: 1,
        order_by: '',
        direction: ''
      }, // 搜索条件
      list: [],
      total: 0,
      height: window.outerHeight - 260 + 'px'
    }
  },
  computed: {
    message_num() {
      return this.$store.getters.message_num
    }
  },
  created() {
    this.getList()
    // this.socketApi.getSock(this.getConfigResult);
    // this.getNewMessage();
    // this.countDown();
  },
  methods: {
    getList() {
      GetUserSystemMessages(this.listQuery).then(response => {
        if (response.data.res_status_code == 0) {
          this.list = response.data.res_content.data_list
          this.total = response.data.res_content.total_count
          this.$store.dispatch(
            'setMessageNum',
            response.data.res_content.sum_data
          )
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    handleToRead(item) {
      if (item.url) this.$router.push({ path: item.url })
      SetMessageToRead(item).then(response => {
        if (response.data.res_status_code == 0) {
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    handleReadAll() {
      SetAllMessagesToRead().then(response => {
        if (response.data.res_status_code == 0) {
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    getConfigResult(res) {
      this.sendMsg(res.data)
    },
    getNewMessage() {
      GetNewUserSystemMessages().then(response => {
        if (response.data.res_status_code == 0) {
          if (response.data.res_content.data_list.length > 0) {
            this.getList()
          }
          response.data.res_content.data_list.forEach((element, index) => {
            if (index <= 20) {
              this.sendMsg(element)
            }
          })
          this.$store.dispatch(
            'setMessageNum',
            response.data.res_content.sum_data
          )
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    sendMsg(item) {
      var newNotify = () => {
        var notification = new Notification('系统通知:', {
          dir: 'auto',
          requireInteraction: true,
          icon:
            this.BASE_CDN_API + '/erpapi/Uploads/20190828/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20190828112814_9e497e8b-5286-40f4-9aa8-d916cca520cb.jpg',
          body: item.message_text
        })
        notification.onclick = event => {
          // 回到发送此通知的页面
          window.focus()
          this.$router.push({ path: item.url })
          this.handleToRead(item)
          notification.close()
        }
        notification.onclose = () => {
          this.handleToRead(item)
        }
      }
      // 权限判断
      if (Notification.permission == 'granted') {
        setTimeout(() => {
          newNotify()
        }, 1000)
      } else {
        // 请求权限
        Notification.requestPermission(perm => {
          if (perm == 'granted') {
            setTimeout(() => {
              newNotify()
            }, 1000)
          } else {
            setTimeout(() => {
              this.$notify({
                title: '通知',
                message: item.message_text,
                position: 'bottom-left',
                onClick: () => {
                  this.handleToRead(item)
                  if (item.url) this.$router.push({ path: item.url })
                }
              })
            }, 100)
          }
        })
      }
    },
    countDown() {
      const interval = window.setInterval(() => {
        this.getNewMessage()
      }, 10 * 60 * 1000)
    },

    parseTime
  }
}
</script>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
  }

  .drawer-switch {
    float: right;
  }
}
.message_box {
  overflow-y: auto;
  background: #f7f7f7;
  padding: 10px;
}
.message_box p {
  padding: 0;
  margin: 0;
}
</style>
